/* -- Poster Gallery: search, multi-select filters, GSAP flip, modal -- */

/* -- Reduced motion check -- */
var pgReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* -- E: Lazy GSAP flip via IntersectionObserver -- */
function pgInitFlip(card) {
  if (card.getAttribute('data-flip-init')) return;
  card.setAttribute('data-flip-init', '1');
  if (pgReducedMotion) return;
  gsap.set(card, { transformStyle: "preserve-3d", transformPerspective: 1000 });
  var q = gsap.utils.selector(card);
  var front = q(".front");
  var back = q(".back");
  gsap.set(back, { rotationY: -180 });
  var tl = gsap.timeline({ paused: true })
    .to(front, { duration: .5, rotationY: 180 })
    .to(back, { duration: .5, rotationY: 0 }, 0)
    .to(card, { z: 10 }, 0)
    .to(card, { z: 0 }, 0.25);
  card.addEventListener("mouseenter", function() { tl.play(); });
  card.addEventListener("mouseleave", function() { tl.reverse(); });
}

/* E: Lazy init -- only initialize GSAP when cards scroll into view */
var pgFlipObserver;
if ('IntersectionObserver' in window) {
  pgFlipObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        pgInitFlip(entry.target);
        pgFlipObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px' });
  document.querySelectorAll('.poster-card').forEach(function(card) {
    pgFlipObserver.observe(card);
  });
} else {
  /* Fallback: eager init for browsers without IntersectionObserver */
  gsap.utils.toArray(".poster-card").forEach(pgInitFlip);
}

/* -- Main gallery logic -- */
var posterGallery = document.querySelector('.poster-gallery');
if (posterGallery) {
  var pgPanels = posterGallery.querySelectorAll('.poster-gallery__panel');
  var allCards = Array.from(posterGallery.querySelectorAll('.poster-gallery__panel .poster-card'));
  var pgSection = posterGallery.closest('section');
  var pgFeatured = posterGallery.querySelector('.poster-gallery__featured');

  /* D: Read cross-link URL from data attribute */
  var pgLineupUrl = posterGallery.getAttribute('data-lineup-url') || '/pages/lineup-archive';
  var pgShowEditions = posterGallery.getAttribute('data-show-editions') !== 'false';

  var pgSearch = pgSection.querySelector('[id^="pg-search"]');
  var pgResultsCount = pgSection.querySelector('[id^="pg-results-count"]');
  var pgClearBtn = pgSection.querySelector('[id^="pg-clear"]');
  var pgNoResults = pgSection.querySelector('[id^="pg-no-results"]');
  var pgFilteredGrid = pgSection.querySelector('[id^="pg-filtered-grid"]');
  var pgFilterToggle = pgSection.querySelector('[id^="pg-filter-toggle"]');
  var pgFilterDrawer = pgSection.querySelector('[id^="pg-filter-drawer"]');
  var pgFilterBadge = pgSection.querySelector('[id^="pg-filter-badge"]');

  /* Multi-select filter elements */
  var pgFilterYear = pgSection.querySelector('[id^="pg-filter-year"]');
  var pgFilterEvent = pgSection.querySelector('[id^="pg-filter-event"]');
  var pgFilterPerformer = pgSection.querySelector('[id^="pg-filter-performer"]');
  var pgFilterArtist = pgSection.querySelector('[id^="pg-filter-artist"]');
  var pgFilterAvail = pgSection.querySelector('[id^="pg-filter-avail"]');

  /* -- Default to most recent year -- */
  var defaultYear = pgPanels.length > 0 ? pgPanels[0].getAttribute('data-year') : '';

  /* Init: no panels active by default - featured row is the landing view */
  pgPanels.forEach(function(p) {
    p.classList.remove('active');
  });

  /* -- Filter toggle -- */
  pgFilterToggle.addEventListener('click', function() {
    var isOpen = pgFilterDrawer.classList.toggle('open');
    pgFilterToggle.classList.toggle('active', isOpen);
  });

  /* -- Multi-select dropdown logic -- */
  function setupMultiSelect(container) {
    var trigger = container.querySelector('.pg-multi__trigger');
    var dropdown = container.querySelector('.pg-multi__dropdown');
    var label = container.getAttribute('data-label');

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      /* Close other open dropdowns */
      pgSection.querySelectorAll('.pg-multi.open').forEach(function(el) {
        if (el !== container) el.classList.remove('open');
      });
      container.classList.toggle('open');
    });

    dropdown.addEventListener('change', function() {
      updateTriggerLabel(container, label);
      pgApplyFilters();
    });

    dropdown.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  }

  function updateTriggerLabel(container, label) {
    var checked = container.querySelectorAll('input[type="checkbox"]:checked');
    var trigger = container.querySelector('.pg-multi__trigger');
    var svg = '<svg viewBox="0 0 12 12" width="10" height="10"><path d="M2.5 4.5L6 8l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    if (checked.length === 0) {
      trigger.innerHTML = label + ' ' + svg;
    } else {
      trigger.innerHTML = label + ' <span class="pg-multi__count">' + checked.length + '</span> ' + svg;
    }
  }

  function getCheckedValues(container) {
    var vals = [];
    container.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
      vals.push(cb.value);
    });
    return vals;
  }

  /* Close dropdowns on outside click */
  document.addEventListener('click', function() {
    pgSection.querySelectorAll('.pg-multi.open').forEach(function(el) {
      el.classList.remove('open');
    });
  });

  /* -- Helper: get individual artist names from a card -- */
  function getCardArtists(card) {
    var explicit = card.getAttribute('data-artists');
    if (explicit !== null) return explicit.split('|').map(function(s) { return s.trim(); }).filter(function(s) { return s.length > 0; });
    var perf = card.getAttribute('data-performer');
    if (perf) return [perf];
    return [];
  }

  /* -- Populate filter dropdowns from card data -- */
  var eventSet = {};
  var performerSet = {};
  var artistSet = {};
  allCards.forEach(function(c) {
    var ev = c.getAttribute('data-event');
    var art = c.getAttribute('data-artist');
    if (ev) eventSet[ev] = true;
    getCardArtists(c).forEach(function(name) { performerSet[name] = true; });
    if (art) artistSet[art] = true;
  });

  function populateMultiSelect(container, items, addSearch) {
    var dropdown = container.querySelector('.pg-multi__dropdown');
    var sorted = Object.keys(items).sort();

    /* Add search input if more than 20 items */
    if (addSearch && sorted.length > 20) {
      var searchInput = document.createElement('input');
      searchInput.type = 'text';
      searchInput.className = 'pg-multi__search';
      searchInput.placeholder = 'Search...';
      searchInput.setAttribute('aria-label', 'Filter ' + container.getAttribute('data-label'));
      searchInput.addEventListener('input', function() {
        var q = this.value.toLowerCase();
        var labels = dropdown.querySelectorAll('label');
        labels.forEach(function(lbl) {
          var text = lbl.textContent.toLowerCase();
          lbl.style.display = text.indexOf(q) !== -1 ? '' : 'none';
        });
      });
      searchInput.addEventListener('click', function(e) { e.stopPropagation(); });
      dropdown.appendChild(searchInput);
    }

    sorted.forEach(function(val) {
      var lbl = document.createElement('label');
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.value = val;
      var span = document.createElement('span');
      span.textContent = val;
      lbl.appendChild(cb);
      lbl.appendChild(span);
      dropdown.appendChild(lbl);
    });
  }
  /* Event dropdown is pre-populated in Liquid (data-static="true") — skip JS population */
  if (!pgFilterEvent.getAttribute('data-static')) {
    populateMultiSelect(pgFilterEvent, eventSet, false);
  }
  populateMultiSelect(pgFilterPerformer, performerSet, true);
  populateMultiSelect(pgFilterArtist, artistSet, false);

  /* Init multi-selects */
  pgSection.querySelectorAll('.pg-multi').forEach(setupMultiSelect);

  /* -- Filter state -- */
  var pgIsFiltering = false;

  function pgCountActiveFilters() {
    var count = 0;
    pgSection.querySelectorAll('.pg-multi input[type="checkbox"]:checked').forEach(function() { count++; });
    return count;
  }

  function pgHasActiveFilters() {
    return (pgSearch.value.trim() !== '' || pgCountActiveFilters() > 0);
  }

  function pgUpdateBadge() {
    var count = pgCountActiveFilters();
    if (count > 0) {
      pgFilterBadge.textContent = count;
      pgFilterBadge.classList.add('visible');
    } else {
      pgFilterBadge.classList.remove('visible');
    }
  }

  function pgApplyFilters() {
    var query = pgSearch.value.trim().toLowerCase();
    var fYears = getCheckedValues(pgFilterYear);
    var fEvents = getCheckedValues(pgFilterEvent);
    var fPerformers = getCheckedValues(pgFilterPerformer);
    var fArtists = getCheckedValues(pgFilterArtist);
    var fAvails = getCheckedValues(pgFilterAvail);
    pgIsFiltering = pgHasActiveFilters();
    pgUpdateBadge();

    if (pgIsFiltering) {
      /* Hide all panels and featured, show filtered grid */
      pgPanels.forEach(function(p) { p.style.display = 'none'; });
      if (pgFeatured) pgFeatured.style.display = 'none';
      posterGallery.classList.add('pg-filtering');

      pgFilteredGrid.innerHTML = '';
      pgFilteredGrid.classList.add('active');

      var matchCount = 0;
      allCards.forEach(function(card) {
        var name = (card.getAttribute('data-name') || '').toLowerCase();
        var event = card.getAttribute('data-event') || '';
        var performer = card.getAttribute('data-performer') || '';
        var artist = card.getAttribute('data-artist') || '';
        var year = card.getAttribute('data-year') || '';
        var avail = card.getAttribute('data-available') || '';
        var desc = (card.getAttribute('data-description') || '').toLowerCase();

        var match = true;

        /* Text search: match poster name, event, performer, individual artists, visual artist, or description */
        if (query) {
          var textMatch = name.indexOf(query) !== -1 ||
                          event.toLowerCase().indexOf(query) !== -1 ||
                          performer.toLowerCase().indexOf(query) !== -1 ||
                          artist.toLowerCase().indexOf(query) !== -1 ||
                          desc.indexOf(query) !== -1;
          if (!textMatch) {
            var indivArtists = getCardArtists(card);
            for (var ai = 0; ai < indivArtists.length; ai++) {
              if (indivArtists[ai].toLowerCase().indexOf(query) !== -1) { textMatch = true; break; }
            }
          }
          if (!textMatch) match = false;
        }

        if (fYears.length > 0 && fYears.indexOf(year) === -1) match = false;
        if (fEvents.length > 0 && fEvents.indexOf(event) === -1) match = false;
        if (fPerformers.length > 0) {
          var cardPerformers = getCardArtists(card);
          var perfMatch = false;
          for (var pi = 0; pi < cardPerformers.length; pi++) {
            if (fPerformers.indexOf(cardPerformers[pi]) !== -1) { perfMatch = true; break; }
          }
          if (!perfMatch) match = false;
        }
        if (fArtists.length > 0 && fArtists.indexOf(artist) === -1) match = false;
        if (fAvails.length > 0 && fAvails.indexOf(avail) === -1) match = false;

        if (match) {
          var clone = card.cloneNode(true);
          clone.classList.remove('pg-hidden');
          clone.removeAttribute('data-flip-init');
          pgFilteredGrid.appendChild(clone);
          matchCount++;
        }
      });

      /* E: Use observer for cloned cards too */
      pgFilteredGrid.querySelectorAll('.poster-card').forEach(function(card) {
        if (pgFlipObserver) {
          pgFlipObserver.observe(card);
        } else {
          pgInitFlip(card);
        }
      });
      pgResultsCount.textContent = matchCount + ' poster' + (matchCount !== 1 ? 's' : '') + ' found';
      pgNoResults.style.display = matchCount === 0 ? 'block' : 'none';
      pgClearBtn.classList.add('visible');

    } else {
      /* Back to default view */
      pgFilteredGrid.classList.remove('active');
      pgFilteredGrid.innerHTML = '';
      pgNoResults.style.display = 'none';
      pgClearBtn.classList.remove('visible');
      posterGallery.classList.remove('pg-filtering');

      if (pgFeatured) pgFeatured.style.display = '';

      pgPanels.forEach(function(p) {
        p.style.display = '';
        p.classList.remove('active');
      });

      pgResultsCount.textContent = '';
    }
  }

  pgResultsCount.textContent = '';

  /* -- Event listeners -- */
  var pgDebounceTimer;
  pgSearch.addEventListener('input', function() {
    clearTimeout(pgDebounceTimer);
    pgDebounceTimer = setTimeout(pgApplyFilters, 250);
  });

  pgClearBtn.addEventListener('click', function() {
    pgSearch.value = '';
    pgSection.querySelectorAll('.pg-multi input[type="checkbox"]:checked').forEach(function(cb) {
      cb.checked = false;
    });
    pgSection.querySelectorAll('.pg-multi').forEach(function(m) {
      updateTriggerLabel(m, m.getAttribute('data-label'));
    });
    /* Clear search inputs within dropdowns */
    pgSection.querySelectorAll('.pg-multi__search').forEach(function(inp) {
      inp.value = '';
      inp.dispatchEvent(new Event('input'));
    });
    pgApplyFilters();
  });

  /* -- Helper: escape HTML to prevent XSS in modal -- */
  function pgEscapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* -- Modal -- */
  var pgModal = pgSection.querySelector('.poster-modal-wrapper');
  var pgCapUpper = pgModal && pgModal.classList.contains('modal-caption-upper') ? ' uppercase' : '';
  var pgMainBtnClass = (pgModal && pgModal.getAttribute('data-main-btn-class')) || '';
  var pgBtnBold = pgModal && pgModal.getAttribute('data-btn-bold') === 'true';
  function pgBtnLabel(t) { return pgBtnBold ? '<b>' + t + '</b>' : t; }

  /* Move modal to document.body so it escapes <main> stacking context */
  if (pgModal && pgModal.closest('main')) {
    document.body.appendChild(pgModal);
  }

  var pgModalImg = pgModal.querySelector('.poster-modal-left img');
  var pgModalTitle = pgModal.querySelector('.poster-modal-title');
  var pgModalDetails = pgModal.querySelector('.poster-modal-details');
  var pgModalAction = pgModal.querySelector('[id^="poster-modal-action"]');
  var pgCloseBtn = pgModal.querySelector('.poster-modal-close');
  var pgPrevBtn = pgModal.querySelector('.poster-modal-prev');
  var pgNextBtn = pgModal.querySelector('.poster-modal-next');
  var pgCurrentCards = [];
  var pgCurrentIndex = 0;

  function pgOpenModal(cards, index) {
    pgCurrentCards = Array.from(cards);
    pgCurrentIndex = index;
    pgRenderModal();
    pgModal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function pgRenderModal() {
    var card = pgCurrentCards[pgCurrentIndex];
    pgModalImg.src = card.getAttribute('data-image-url') || card.getAttribute('data-image-thumb') || '';
    pgModalImg.alt = card.getAttribute('data-name');
    pgModalTitle.textContent = card.getAttribute('data-name');

    var html = '';
    var artist = card.getAttribute('data-artist');
    var performer = card.getAttribute('data-performer');
    var eventName = card.getAttribute('data-event');
    var desc = card.getAttribute('data-description');
    var eventDate = card.getAttribute('data-event-date');
    var year = card.getAttribute('data-year');

    if (eventName) {
      var eventDisplay = pgEscapeHtml(eventName);
      if (eventDate) {
        eventDisplay += ' (' + pgEscapeHtml(eventDate) + ')';
      } else if (year) {
        eventDisplay += ' (' + pgEscapeHtml(year) + ')';
      }
      html += '<div><span class="poster-modal-detail-label caption-font' + pgCapUpper + '">Event</span><span class="poster-modal-detail-value body-font">' + eventDisplay + '</span></div>';
    }
    if (performer) {
      html += '<div><span class="poster-modal-detail-label caption-font' + pgCapUpper + '">Performing Artist</span><span class="poster-modal-detail-value body-font">' + pgEscapeHtml(performer) + '</span></div>';
    }
    if (artist) {
      html += '<div><span class="poster-modal-detail-label caption-font' + pgCapUpper + '">Illustrated by</span><span class="poster-modal-detail-value body-font">' + pgEscapeHtml(artist) + '</span></div>';
    }

    /* Parse edition info and measurements from description (gated by show_edition_info setting) */
    var edLines = [];
    var measMatch = null;
    if (pgShowEditions && desc) {
      var editionRegex = /([\w\/\s'".\-]+?)\s*[-\u2013\u2014]\s*edition of (\d+)(?:\s*\(([^)]+)\))?/gi;
      var edMatch;
      while ((edMatch = editionRegex.exec(desc)) !== null) {
        var edType = edMatch[1].trim();
        var edSize = edMatch[2];
        var edStatus = edMatch[3] ? ' (' + pgEscapeHtml(edMatch[3]) + ')' : '';
        edLines.push(pgEscapeHtml(edType) + ': edition of ' + edSize + edStatus);
      }
      measMatch = desc.match(/Measures\s+([\d"''\s\u00d7x\u00d7]+[\d"''])/i);
    }

    if (edLines.length > 0) {
      html += '<div><span class="poster-modal-detail-label caption-font' + pgCapUpper + '">Editions</span>';
      for (var i = 0; i < edLines.length; i++) {
        html += '<span class="poster-modal-detail-value poster-modal-edition-line body-font">' + edLines[i] + '</span>';
      }
      html += '</div>';
    }
    if (measMatch) {
      html += '<div><span class="poster-modal-detail-label caption-font' + pgCapUpper + '">Measurements</span><span class="poster-modal-detail-value body-font">' + pgEscapeHtml(measMatch[1].trim()) + '</span></div>';
    }

    /* D: Cross-link to lineup archive using data attribute URL */
    var cardYear = card.getAttribute('data-year');
    var cardEvent = card.getAttribute('data-event');
    if (cardYear) {
      var lineupParams = '?year=' + encodeURIComponent(cardYear);
      if (cardEvent) lineupParams += '&event=' + encodeURIComponent(cardEvent);
      html += '<div class="poster-modal-lineup-cta"><a href="' + pgEscapeHtml(pgLineupUrl) + lineupParams + '" class="poster-modal-lineup-link caption-font' + pgCapUpper + '">View This Lineup <span>&rsaquo;</span></a></div>';
    }

    pgModalDetails.innerHTML = html;

    /* C: Action button -- variant-aware */
    var variantsAttr = card.getAttribute('data-variants');
    var variants = null;
    if (variantsAttr) {
      try { variants = JSON.parse(variantsAttr); } catch(e) {}
    }

    if (variants && variants.length > 0) {
      /* Multiple variants: show a button per variant */
      var actionHtml = '<div class="poster-modal-variants">';
      for (var vi = 0; vi < variants.length; vi++) {
        var v = variants[vi];
        if (v.url && v.available !== false) {
          actionHtml += '<a href="' + pgEscapeHtml(v.url) + '" data-pg-verify="' + (v.available === true ? '0' : '1') + '" class="poster-modal-shop poster-modal-variant-btn ' + pgMainBtnClass + '">' + pgBtnLabel(pgEscapeHtml(v.label)) + '</a>';
        } else {
          actionHtml += '<span class="poster-modal-soldout poster-modal-variant-btn">' + pgEscapeHtml(v.label) + ' (Sold Out)</span>';
        }
      }
      actionHtml += '</div>';
      pgModalAction.innerHTML = actionHtml;
      pgModalAction.querySelectorAll('a[data-pg-verify="1"]').forEach(function(btn){
        pgVerifyAvail(btn.getAttribute('href'), function(avail){
          if (!avail) {
            var lbl = btn.textContent;
            var span = document.createElement('span');
            span.className = 'poster-modal-soldout poster-modal-variant-btn';
            span.textContent = lbl + ' (Sold Out)';
            btn.replaceWith(span);
          }
        });
      });
    } else {
      /* Single product or no product */
      var availAttr = card.getAttribute('data-available');
      var url = card.getAttribute('data-url');
      if (url && availAttr !== 'false') {
        pgModalAction.innerHTML = '<a href="' + pgEscapeHtml(url) + '" class="poster-modal-shop ' + pgMainBtnClass + '">' + pgBtnLabel('Shop This Print') + '</a>';
        if (availAttr !== 'true') {
          pgVerifyAvail(url, function(avail){
            if (!avail) pgModalAction.innerHTML = '<span class="poster-modal-soldout">Sold Out</span>';
          });
        }
      } else if (url) {
        pgModalAction.innerHTML = '<span class="poster-modal-soldout">Sold Out</span>';
      } else {
        pgModalAction.innerHTML = '';
      }
    }

    pgPrevBtn.style.visibility = pgCurrentIndex === 0 ? 'hidden' : 'visible';
    pgNextBtn.style.visibility = pgCurrentIndex === pgCurrentCards.length - 1 ? 'hidden' : 'visible';
  }

  /* Client-side availability: Liquid's all_products caps at 20 unique handles per
     render, so cards beyond that carry data-available="unknown". Verify via the
     storefront product JSON when the modal opens; cache per URL. */
  var pgAvailCache = {};
  function pgVerifyAvail(url, onResult) {
    if (!url) return;
    var path = url.split('?')[0];
    if (Object.prototype.hasOwnProperty.call(pgAvailCache, path)) { onResult(pgAvailCache[path]); return; }
    fetch(path + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
      var avail = p ? !!p.available : true; /* fail open: never block a sale on a fetch error */
      pgAvailCache[path] = avail;
      onResult(avail);
    }).catch(function(){ pgAvailCache[path] = true; onResult(true); });
  }

  function pgCloseModal() {
    pgModal.classList.remove('active');
    document.body.style.overflow = '';
    pgModalImg.src = '';
  }

  pgCloseBtn.addEventListener('click', pgCloseModal);
  pgModal.addEventListener('click', function(e) {
    if (e.target === pgModal || e.target.classList.contains('poster-modal-nav-wrapper')) pgCloseModal();
  });
  pgPrevBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    if (pgCurrentIndex > 0) { pgCurrentIndex--; pgRenderModal(); }
  });
  pgNextBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    if (pgCurrentIndex < pgCurrentCards.length - 1) { pgCurrentIndex++; pgRenderModal(); }
  });
  document.addEventListener('keydown', function(e) {
    if (!pgModal.classList.contains('active')) return;
    if (e.key === 'Escape') pgCloseModal();
    if (e.key === 'ArrowLeft' && pgCurrentIndex > 0) { pgCurrentIndex--; pgRenderModal(); }
    if (e.key === 'ArrowRight' && pgCurrentIndex < pgCurrentCards.length - 1) { pgCurrentIndex++; pgRenderModal(); }
  });

  pgSection.addEventListener('click', function(e) {
    var btn = e.target.closest('.open-bio-modal');
    if (!btn) return;
    var card = btn.closest('.poster-card');
    if (!card) return;
    var container = card.closest('.poster-gallery__filtered-grid') || card.closest('.poster-gallery__grid');
    if (!container) return;
    var visibleCards = container.querySelectorAll('.poster-card:not(.pg-hidden)');
    var idx = Array.from(visibleCards).indexOf(card);
    if (idx < 0) return;
    pgOpenModal(visibleCards, idx);
  });

  /* -- Auto-apply filters from URL params (cross-link from lineup archive) -- */
  (function() {
    var params = new URLSearchParams(window.location.search);
    var urlYear = params.get('year');
    var urlEvent = params.get('event');
    if (!urlYear && !urlEvent) return;

    /* Hide featured row immediately to prevent flash of unfiltered state */
    if (pgFeatured) pgFeatured.style.display = 'none';
    pgPanels.forEach(function(p) { p.style.display = 'none'; });

    var changed = false;

    if (urlYear) {
      pgFilterYear.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
        if (cb.value === urlYear) { cb.checked = true; changed = true; }
      });
      updateTriggerLabel(pgFilterYear, pgFilterYear.getAttribute('data-label'));
    }

    if (urlEvent) {
      pgFilterEvent.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
        if (cb.value === urlEvent) { cb.checked = true; changed = true; }
      });
      updateTriggerLabel(pgFilterEvent, pgFilterEvent.getAttribute('data-label'));
    }

    if (changed) {
      pgFilterDrawer.classList.add('open');
      pgFilterToggle.classList.add('active');
      pgApplyFilters();
      /* Clean URL params without triggering reload */
      if (window.history.replaceState) {
        var cleanUrl = window.location.pathname;
        window.history.replaceState({}, '', cleanUrl);
      }
    }
  })();
}

/* v2026-07-10b */
